import Immutable from 'immutable'
import moment from 'moment'

/**
 * Managed and created by makeSelectOfferFilterData from product selectors
 */
export const OfferFilterDataRecord = Immutable.Record({
  contracts: Immutable.OrderedSet(),
  disabledProducts: Immutable.OrderedSet(),
  periods: Immutable.OrderedSet(),
  products: Immutable.OrderedSet(),
  speeds: Immutable.OrderedSet(),
  speedsWithAttributes: Immutable.OrderedSet()
}, 'OfferFilterData')

export const OfferFilterRecord = Immutable.Record({
  addressSupplied: false, // Used by product selectors
  allowCalix: false,
  contract: null,
  hasIpn: false,
  period: moment.duration('P1M'),
  productId: null,
  speed: null,
  upgradeGroup: null,
}, 'OfferFilter')

export default function createOfferFilter(data) {
  return new OfferFilterRecord(data)
}

export function filterOffer(filter, offer) {
  if (!filter) {
    return true
  }

  if (!filter.hasIpn && offer.attributes.has('ipn')) {
    return false
  }

  if (offer.attributes.has('calix') && !filter.allowCalix) {
    return false
  }

  if (
    filter.period && (
      // Offer has no period. Shouldn't happen.
      !offer.period ||
      // Offer's period does not match the filter.
      offer.period.asMonths() !== filter.period.asMonths()
    )
  ) {
    return false
  }

  if (
    filter.contract && (
      // Filter Contract length is defined as 0 but the offer has a contract length
      (filter.contract.asMonths() === 0 && offer.contractLength) ||
      // Filter contract length is not 0 and filter has no contract or does not match
      (filter.contract.asMonths() !== 0 && (
        !offer.contractLength ||
        offer.contractLength.asMonths() !== filter.contract.asMonths()
      ))
    )
  ) {
    return false
  }

  if (
    filter.productId && (
      // Offer isnt of the specified product
      filter.productId !== offer.product
    )
  ) {
    return false
  }

  if (
    filter.speed && (
      // Offer isnt of the specified speed
      filter.speed !== offer.speed
    )
  ) {
    return false
  }

  if (
    filter.upgradeGroup && (
      filter.upgradeGroup !== offer.upgradeGroup
    )
  ) {
    return false
  }

  if (filter.attribute && !offer.attributes.includes(filter.attribute)) {
    return false;
  }

  return true
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/OfferFilter.js